<div mat-dialog-title class="flex justify-between items-center p-2">
    <h1 class="font-bold text-lg text-[#0C2A63]">Preview</h1>
    <div class="flex space-x-2">
        <mat-icon class="hover:text-[#0C2A63]" (click)="downloadDoc()">cloud_download</mat-icon>
        <mat-icon class="hover:text-red" (click)="close()">close</mat-icon>
    </div>
</div>
<div mat-dialog-content class="max-h-[500px] w-full p-2">
    <div class="flex w-full justify-center">

        <div class="w-full" *ngIf="extension !== 'gif' && extension !== 'png' && extension !== 'jpeg'" #viewerWrapper>
            <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white z-10">
            </div>
            <ngx-doc-viewer [url]="url" viewer="google"
                class="w-full h-[400px] border-none outline-none shadow-none p-0 m-0" style="border: none;">
            </ngx-doc-viewer>
        </div>
        <div *ngIf="extension === 'gif' || extension === 'png' || extension === 'jpeg'">
            <img [src]="url" alt="manual" class="w-[400px] h-[400px]">
        </div>
    </div>
</div>